/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import BottomActions from '@/components/bottomActions/BottomActions';
import { Outlet } from 'react-router-dom';

const DashboardLayout = () => {
    return (
        <div data-testid="dashboard-layout">
            <Outlet />
            <BottomActions />
        </div>
    );
};

export default DashboardLayout;
